import { Component, computed, ElementRef, Inject, viewChild, viewChildren } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { jsPDF } from "jspdf";
import { Direction, Edge, FlexDirection, loadYoga } from 'yoga-layout/load';
import { KopConfigService } from '../../core/kop-config.service';
import { JSBridgeService } from '../../core/jsbridge.service';
import { KanaalService } from '../kanaal.service';
import { HwdConfigService } from '../hwd-config.service';
import { applyStyle, FlexStyle } from '../../pdf/FlexStyle';
import { A4MM, BasePDFNode, getYoga, initYoga, RectPDFNode, TextPDFNode } from '../../pdf/BasePDFNode';
import { RackPDFNode } from '../../pdf/RackPDFNode';
import { buildKanaalMap } from '../kanaal.utils';
import { MainboardPDFNode } from '../../pdf/MainboardPDFNode';
import { SC900MainRackNode } from '../../pdf/SC900IONode';
import { PageCardNode } from '../../pdf/PageCardNode';
import { ServerAPI } from '../../serverapi';
import { ModbusPDFNode } from '../../pdf/ModbusPDFNode';
import { wasmVectorToArray } from '../../utils/wasmVector';
import { TranslateService } from '../../i18n/translate.service';
import { HwdSysteem } from '../hdw-config/HdwSysteem';

@Component({
  selector: 'hdw-pdf',
  templateUrl: './hdw-pdf.component.html',
  styles: `
  .iframe2 {
    width: 100%;
    height: calc(90vh - 140px);
  }
  .main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    max-height: calc(90vh - 140px);
  }
  .pdf-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // overflow-y: auto;
    // max-height: calc(90vh - 140px);
  }
  .splitter {
    display: flex;
    flex-direction: column;
  }`,
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'pdf'
    }
  ]
})
export class HdwPdfComponent {

  constructor(private kopConfigService: KopConfigService,
    public jsBridgeService: JSBridgeService, private kanaalService: KanaalService,
    private hdwConfigService: HwdConfigService,
    @Inject('ServerApi') public electronAPI: ServerAPI,
    private translateService: TranslateService) {

  }
  iframe = viewChild<ElementRef<HTMLIFrameElement>>('iframe');


  public assign = computed(() => {
    this.kopConfigService.afdelings();
    this.kopConfigService.selectedAfd();
    this.translateService.kopDataDBSignal();
    let kfg = this.jsBridgeService.getBridgeSync().getConfig();
    let assignement = this.kanaalService.getKonfigKanalen(kfg);
    return assignement;
  });


  public system = computed(() => {
    return this.hdwConfigService.system();
  });


  ngAfterViewInit() {
    this.onRender();
  }

  public modbusNetworks = computed(() => {
    let kopConfig = this.jsBridgeService.kopConfig();
    if (kopConfig != undefined) {
      let mb = wasmVectorToArray(kopConfig.gModBusNetworks);
      let ret = mb.map(m => {
        return {
          index: m.idNr,
          label: m.name.toString()
        }
      });
      ret.unshift({ index: 0, label: 'Geen' });
      return ret;
    }
    return [];
  });

  public pdf: jsPDF | undefined;
  public pdfTooLarge = false;

  getLastRackForFastLink(system: HwdSysteem) {

    let lastRackId = -1;
    let lastXTid = -1;
    let maxSwitch = -1;
    let buses = system.getBusTypes();
    for (let b of buses) {
      let racks = system.getRacks(b);
      for (let r of racks) {
        let firstKaart = r.kaarten[0];
        if ((r.kaarten.length > 0) && (r.kaarten[0].type.metaId == 'mainRackXtender')) {
          
          if (r.kaarten[0].dipSwitch > maxSwitch) {
            maxSwitch = r.kaarten[0].dipSwitch;
            lastRackId = r.id;
            lastXTid = r.kaarten[0].id;
          }
        }
      }
    }
    return lastRackId;
  }

  async onRender() {
    let a = this.assign();
    let kanaalMap = buildKanaalMap(a);
    let system = this.hdwConfigService.system();
    let ifr = this.iframe();

    let klantNo = this.jsBridgeService.getKlantNo();

    let hInfo = await this.electronAPI.getUnlockKlantInfo(klantNo);
    let naam = `${hInfo?.voornaam} ${hInfo?.achternaam}`;
    let db = this.translateService.kopDataDBSignal();


    if (ifr != undefined) {

      this.pdf = new jsPDF({
        //orientation: "l",
        format: "a3",
        unit: 'mm',
        // hotfixes: ["px_scaling"]
      });
      await initYoga();
      let Yoga = getYoga();

      if (system != undefined) {
        let pageCard = new PageCardNode(this.pdf, this.translateService, this.jsBridgeService.getKlantNo(), naam);
        pageCard.init();
        pageCard.applyStyles();

        if (system.getIOs().length > 0) {
          let mainboardNode = new MainboardPDFNode(this.pdf, this.translateService, kanaalMap, system);
          mainboardNode.init();
          mainboardNode.applyStyles();
          mainboardNode.render();
          mainboardNode.layout.freeRecursive();
          pageCard.render();
        } else {
          this.pdf.deletePage(1);
        }

        let buses = system.getBusTypes();
        let lastXTRackId = this.getLastRackForFastLink(system);
        for (let b of buses) {
          let racks = system.getRacks(b);
          for (let rack of racks) {
            let rackNode;
            if (rack.kaarten.length > 0 && rack.kaarten[0].type.metaId == "scx_900") {
              rackNode = new SC900MainRackNode(this.pdf, kanaalMap, rack);
            } else {
              rackNode = new RackPDFNode(this.pdf, kanaalMap, rack, lastXTRackId == rack.id);
            }
            rackNode.pageCard = pageCard;
            rackNode.init();
            rackNode.applyStyles();
            rackNode.render();
            rackNode.layout.freeRecursive();
          }
        }
        let mbNode = new ModbusPDFNode(this.pdf, this.translateService, a, this.modbusNetworks(), pageCard);
        mbNode.init();
        mbNode.applyStyles();
        mbNode.render();
        mbNode.layout.freeRecursive();

        pageCard.layout.freeRecursive();
      }



      let base64 = this.pdf!.output('datauristring');
      console.log(base64.length);
      //let ret = this.sanitizer.bypassSecurityTrustResourceUrl(base64);
      if (base64.length > 1500000) {
        this.pdfTooLarge = true;
      } else {
        ifr.nativeElement.src = base64;
        this.pdfTooLarge = false;
      }

    };


  }

  public onDownload() {
    if (this.pdf == undefined) {
      return;
    }
    let klantNo = this.jsBridgeService.getKlantNo();
    let blob = new Blob([this.pdf.output('blob')], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const b = document.createElement('a');
    b.setAttribute('style', 'display:none');
    document.body.appendChild(b);
    b.href = url;
    b.download = `${klantNo}.pdf`;
    b.click();
    window.URL.revokeObjectURL(url);

  }
}
